// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"62b700a6","58":"d28981f1","124":"c8e46bb6","159":"1b5ad718","238":"870f9e51","333":"187915c9","432":"98fc698a","452":"dc1603a0","488":"8f11bb77","713":"814d8ed0","851":"5481a7c9","941":"eaee4a36"}[chunkId] + ".chunk.js";
};